<script setup>
import EmailFrequency from "@/components/settings/notifications/EmailFrequency.vue";
import AgencyKitEmailRecipients from "@/components/settings/notifications/AgencyKitEmailRecipients.vue";
import LoadingBlock from "@/components/global-themed/LoadingBlock.vue";
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import useEmailSettings from "@/composables/email-settings/useEmailSettings";
import useUser from "@/composables/useUser";
import {computed} from "vue";
import AccordionTransition from "@/components/transitions/AccordionTransition.vue";

const {settingsQuery, agencyKitEmailRecipientsQuery} = useEmailSettings();
const {isLoading: isSettingsLoading} = settingsQuery;
const {isLoading: isRecipientsLoading } = agencyKitEmailRecipientsQuery;
const { canManageEmailSettings } = useUser();

const showKitEmailRecipients = computed(() => canManageEmailSettings.value && !isRecipientsLoading.value);

defineProps({
  showEditEmailTemplatesButton: {
    type: Boolean,
    required: false,
    default: false,
  },
});
</script>

<template>
  <div class="tw-m-auto tw-max-w-default-container">
    <div class="tw-flex tw-flex-col tw-gap-y-8">
      <div class="tw-flex tw-flex-center tw-justify-between">
        <h1 class="tw-font-bold tw-text-4.5xl">
          Email Settings
        </h1>
        <DefaultButton
          v-if="showEditEmailTemplatesButton"
          variant="primary-inverted"
          as="a"
          href="/mail"
          class="tw-h-13"
        >
          <span class="tw-font-normal">Edit Email Templates</span>
        </DefaultButton>
      </div>

      <LoadingBlock v-if="isSettingsLoading" />

      <template v-else>
        <EmailFrequency />

        <AccordionTransition>
          <AgencyKitEmailRecipients
            v-if="showKitEmailRecipients"
            class="tw-transition-all tw-duration-300 tw-ease-in-out"
          />
        </AccordionTransition>
      </template>
    </div>
  </div>
</template>
